<template>
  <div class="app">
    <Home/>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>
.app {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: url("./assets/bg.png");
  background-color: #000;
  display: flex;
  justify-content: center;
}
::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
}
</style>
